module.exports = __webpack_public_path__ + "img/voucher-background-m.33abe28.png";